module.exports = __webpack_public_path__ + "static/media/mainserver.d4052fae.png";